module.exports = __webpack_public_path__ + "assets/img/dvipuse-apskaita.cbf97cd6.jpg";